// extracted by mini-css-extract-plugin
export var assigneeBadge = "_ia-0";
export var assigneeDetails = "_ia-1";
export var assigneeInfo = "_ia-2";
export var dropdownContainer = "_ia-4";
export var dropdownImage = "_ia-5";
export var editAssigneeInfo = "_ia-3";
export var editAssigneeModalContainer = "_ia-6";
export var hidden = "_ia-8";
export var input = "_ia-7";